module.exports = __webpack_public_path__ + "static/media/mycart login_logo.bfa4d432.png";